import type { Dataset, ModelData } from "./index";

export interface ModelStat {
  id: string;
  name: string;
  vendor: string;
  correct: number;
  total: number;
  accuracy: number;
}

export function buildMatrixDatasetView(dataset: Dataset) {
  const modelStats: ModelStat[] = dataset.models.map((m) => {
    const total   = dataset.problems.length;
    const correct = Object.values(m.results).filter((r) => r.correct).length;
    return { id: m.id, name: m.name, vendor: m.vendor, correct, total, accuracy: correct / total };
  });

  const overallAccuracy =
    modelStats.reduce((s, m) => s + m.accuracy, 0) / modelStats.length;

  return { modelStats, overallAccuracy };
}
